'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _durationSecHelper = require('./durationSecHelper');

var _durationSecHelper2 = _interopRequireDefault(_durationSecHelper);

var _extractMinMaxInUnits = require('./extractMinMaxInUnits');

var _extractMinMaxInUnits2 = _interopRequireDefault(_extractMinMaxInUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contracts, type) {
    if (type.indexOf('SPREAD') > -1) {
        return [];
    }

    var tickContracts = contracts.filter(function (c) {
        return c.min_contract_duration.slice(-1) === 't';
    });
    var tickDuration = tickContracts.length > 0 ? { min: 5, max: 10, unit: 't' } : undefined;

    var nonTickContracts = contracts.filter(function (c) {
        return c.min_contract_duration.slice(-1) !== 't';
    });
    if (nonTickContracts.length === 0) {
        return tickDuration ? [tickDuration] : [];
    }
    var nonTickMinSec = nonTickContracts.map(function (c) {
        return (0, _durationSecHelper2.default)(c.min_contract_duration);
    }).filter(function (d) {
        return !!d;
    }).reduce(function (a, b) {
        return Math.min(a, b);
    });

    var nonTickMaxSec = nonTickContracts.map(function (c) {
        return (0, _durationSecHelper2.default)(c.max_contract_duration);
    }).filter(function (d) {
        return !!d;
    }).reduce(function (a, b) {
        return Math.max(a, b);
    });

    var nonTicksDuration = (0, _extractMinMaxInUnits2.default)(nonTickMinSec, nonTickMaxSec);
    if (tickDuration) {
        nonTicksDuration.unshift(tickDuration);
    }

    return nonTicksDuration;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/duration/extractDurationHelper.js
// module id = 289
// module chunks = 0